import React from "react";
import { StyledButtonTeal } from "../components/styled_button";
import Backdrop from "@mui/material/Backdrop";
import { Stack } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate } from "react-router-dom";
import Topbar from "../navigation/topBar";
import { useMsal } from "@azure/msal-react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { ReactComponent as Logo } from "./logo.svg"
import "./login.css";
import CaiPng from "./constems.png";
import Divider from '@mui/material/Divider';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GrainIcon from '@mui/icons-material/Grain';
import AppsIcon from '@mui/icons-material/Apps';
import InsightsIcon from '@mui/icons-material/Insights';
import { useNavigate } from "react-router-dom";

export default function CaiLogin() {
  const { instance } = useMsal();
  const [user, setUser] = React.useState(null);
  const [pass, setPass] = React.useState(null);

  const navigate = useNavigate();

  const handleSignIn = () => {
    instance.loginRedirect({
      scopes: ['user.read']
    })
  }

  const container_styles = {
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    color: "rgb(61,162,131)",
    justifyContent: "center",
    alignItems: "center",
  };

  const handleSubmit = e => {
    e.preventDefault();
  }

  const handleUserChange = (e) => {
    setUser(e.target.value)
  }

  const handlePassChange = (e) => {
    setPass(e.target.value)
  }

  const handleInputLogin = () => {
    if (user === 'ins_user' && pass === 'insAnalytics@352') {
      navigate('/home')
    }
    else if (user === 'test' && pass === 'test@123') {
      navigate('/home')
    }
  }

  return (
    <>
      <UnauthenticatedTemplate>
        <div className="login-container">
          {/* <Constems style={{ width: "25em", height: "25em" }} /> */}
          <div className="logo">
            <span style={{ color: "rgba(105, 210, 255, 1)", fontSize: "4em", fontFamily: "Virgil" }}>CONSTEMS-AI</span>          
          </div>
          <div className="login-form">
            <form onSubmit={handleSubmit}>
              <Stack className="entry-form" direction="column" spacing={3}>
                <input
                  className="login-input"
                  type="text"
                  placeholder="username"
                  onChange={handleUserChange}
                  required
                />

                <input
                  className="login-input"
                  type="password"
                  placeholder="password"
                  onChange={handlePassChange}
                  required
                />

                <button className="msal-login-button" type="submit" onClick={handleInputLogin}>
				<div className="msal-icon">
                <span>Login</span> 
              </div>
                </button>
              </Stack>
            </form>

            {/* <Divider className="login-divider">or</Divider>

            <button className="msal-login-button" onClick={handleSignIn}>
              <div className="msal-icon">
                <span>Login with</span> <MicrosoftIcon style={{ fontSize: "1.25em" }} />
              </div>
            </button> */}
          </div>
        </div>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Navigate to="/home" />
      </AuthenticatedTemplate>
    </>
  )
}